import * as React from "react";
import PaymentLayout from "../layout/paymentLayout";
import PaymentForm from "./form";


const withLayout = (Component: React.Element) => function LayoutWrapper(props: any) {
    return (
        <PaymentLayout>
            <Component {...props} />
        </PaymentLayout>
    );
};

export default {
    PaymentForm: withLayout(PaymentForm),
};